/* @ngInject */
function AssetPreviewUnavailableController ($scope, AssetService) {
  const api = {}
  this.getApi = () => api

  activate()

  function activate () {
  }

  $scope.downloadAsset = function (asset) {
    AssetService.downloadAsset(asset.assetId || asset.id)
  }
}

export { AssetPreviewUnavailableController }
